import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { messages } from '@optimusgps/optimus-intl';
import { Button, Result } from 'antd';

const NotFound = () => {
	const intl = useIntl();
	const user = useSelector((state) => state.auth.user);
	const navigate = useNavigate();
	const actions = (
		<Button type="primary" onClick={() => navigate('/')}>
			{intl.formatMessage(messages.home)}
		</Button>
	);
	return (
		<Result
			status="404"
			subTitle={intl.formatMessage({ ...messages.youAreLost }, { name: user ? user.name : '' })}
			extra={actions}
		/>
	);
};

export default NotFound;
